<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap"><div class="illustration"><img alt="image" src="images/img014.jpg"/>
<p class="figcap"><b><i>Life Springs Anew</i> </b></p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?2b469a40